import { render, staticRenderFns } from "./ExtensionLoader.vue?vue&type=template&id=03c9c3e4"
import script from "./ExtensionLoader.vue?vue&type=script&lang=js"
export * from "./ExtensionLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports